import React from "react";
import { lazyWithRetry as lazy } from "../utils/lazyWithRetry";
import { useAuth } from "../contexts/AuthContext";

// Chargé à la demande : jamais téléchargé par un tenant resté en v1.
const ModuleHoraireV2 = lazy(() => import("./ModuleHoraireV2"));

// Vrai seulement si parametres.horaire.version === "v2". Tout le reste = v1.
export const tenantUtiliseHoraireV2 = (tenant) =>
  tenant?.parametres?.horaire?.version === "v2";

// Onglet de Paramètres (v1) remplacé par le Module Horaire V2 : le catalogue s'édite dans F8.
export const ongletRemplaceParV2 = (tenant, ongletId) =>
  ongletId === "types-garde" && tenantUtiliseHoraireV2(tenant);

/**
 * Aiguilleur du module Horaire : affiche l'horaire v1 (reçu en `classique`,
 * rendu tel quel) ou le Module Horaire V2 selon le paramètre du tenant.
 */
const HoraireAiguilleur = ({ classique }) => {
  const { tenant } = useAuth();
  return tenantUtiliseHoraireV2(tenant) ? <ModuleHoraireV2 /> : classique;
};

export default HoraireAiguilleur;
